import { useEffect, useState } from 'react';

export const useDollarExchangeRate = () => {
	const [rateValue, setRateValue] = useState<number>(0);

	useEffect(() => {
		fetch('https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?json')
			.then(response => {
				if (!response.ok) {
					throw new Error('Network Error');
				}
				return response.json();
			})
			.then(data => {
				const { rate } = data.find(
					({ r030 }: { r030: number }) => r030 === 840
				);

				setRateValue(rate);
			})
			.catch(error => {
				console.error('Сталася помилка:', error);
			});
	}, []);

	return rateValue;
};
